import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Store } from "@softline/core";
import { Router } from "@angular/router";
import {
    BackNavigationService, HeaderComponent,
    SOFTLINE_FEATURE_TITLE,
    Step,
    StepHeaderComponent,
    TitleStore
} from "@softline/application";
import { UiCoreModule } from "@softline/ui-core";
import { SOFTLINE_FEATURE_LAGERKORREKTUR } from "../../lagerkorrektur.shared";
import { LagerkorrekturStore } from "../../store";
import { ArtikelMenge, ArtikelMengeAuswahlComponent } from "@softapps/lager/core";

@Component({
    selector: 'soft-artikel-auswahl',
    imports: [CommonModule, UiCoreModule, StepHeaderComponent, ArtikelMengeAuswahlComponent, HeaderComponent],
    templateUrl: './artikel-auswahl.page.html',
    styleUrls: ['./artikel-auswahl.page.css']
})
export class ArtikelAuswahlPage implements OnInit {

  readonly steps: Step[] = [
    {
      header: '#LAGERKORREKTUR.PAGES.LAGERPLATZ_SCANNEN.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.LAGERPLATZ_SCANNEN.DESCRIPTION'
    },
    {
      header: '#LAGERKORREKTUR.PAGES.ARTIKEL_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.ARTIKEL_AUSWAHL.DESCRIPTION'
    },
    {
      header: '#LAGERKORREKTUR.PAGES.MENGEN_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.MENGEN_AUSWAHL.DESCRIPTION'
    },
    {
      header: '#LAGERKORREKTUR.PAGES.LAGERSYMBOL_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.LAGERSYMBOL_AUSWAHL.DESCRIPTION'
    },
  ];

  lagerplatz$ = this.store.observe(SOFTLINE_FEATURE_LAGERKORREKTUR, LagerkorrekturStore.getters.lagerplatz);

  constructor(private store: Store,
              private router: Router,
              private backNavigationService: BackNavigationService) {
  }

  ngOnInit(): void {
    this.backNavigationService.set(this);
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '#LAGERKORREKTUR.TITLE')
  }

  ngOnDestroy() {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '')
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/lagerkorrektur'])
  }

  async onSelect(artikel: ArtikelMenge): Promise<void> {
    this.store.commit(SOFTLINE_FEATURE_LAGERKORREKTUR, LagerkorrekturStore.mutations.setArtikel, {...artikel});
    await this.router.navigate(['/lagerkorrektur', 'mengen-auswahl'])
  }
}
